// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const FedoraIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <path
      fill="#51A2DA"
      d="M12 1C5.8 1 .8 5.92.78 12v8.5c0 1.38 1.14 2.5 2.55 2.5H12a11.1 11.1 0 0 0 11.22-11c0-6.07-5.03-10.99-11.23-10.99z"
    />
    <path
      fill="#fff"
      d="M14.28 5.52c-1.75 0-3.3 1.3-3.5 2.99q-.03.2-.02.37v6.93a2.2 2.2 0 0 1-2.29 2.23c-1.27 0-2.29-1-2.29-2.23.02-1.37 1.13-2.23 2.43-2.27l1.33-.01V11.7l-1.32.01a4.2 4.2 0 0 0-4.3 4.1 4.13 4.13 0 0 0 4.15 4.06 4.15 4.15 0 0 0 4.14-3.7c.03-.7.02-1.63.02-1.63v-1l1.63-.01c1.26 0 1.25-1.86-.02-1.84l-1.62.02q.02-1.41 0-2.82c0-.81.8-1.53 1.66-1.53.88 0 1.8.43 1.8 1.53l-.01.31a.93.93 0 1 0 1.85.26q.04-.3.03-.57c0-1.95-1.78-3.36-3.67-3.36"
    />
  </svg>,
  "Fedora",
);
export default FedoraIcon;
